<template>
  <div class="content">
    <DownloadPageList
      :downloadPageList="downloadPageList"
      :downloadPageListTitle="langJson[lang].downloadTitle || ''"
      :itemSubtitleNeeded="false"
    />
  </div>
</template>

<script setup lang="ts">
  import { useMainStore } from '~/stores/main';

  definePageMeta({ middleware: 'check-token' });

  const store = useMainStore();
  const langJson = computed(() => store.langJson);
  const lang = computed(() => store.lang);
  const categories = computed(() => store.categories);
  const downloadPageList = computed(() => {
    return categories.value
      .filter((item) => item.productBlockType === 'DownloadSection')
      .map((item) => ({
        nodeId: String(item.nodeId),
        external: { title: item.title || '' },
        nodes:
          item.nodes?.map((node) => ({
            id: String(node.id),
            nodeId: String(node.nodeId),
            productBlockType: node.productBlockType || '',
            resources: node.resources,
            external: typeof node.external === 'object' ? node.external : undefined,
            title: node.title,
            fileName: (node as any).fileName
          })) || []
      }));
  });
</script>
